<template>
  <div>
    <b-img :width="size" :height="size" v-if="base64Data" class="profile-image" fluid :src="base64Data ? 'data:image/png;base64, ' + base64Data : ''" rounded="circle" alt="Profile image"></b-img>
    <b-img :width="size" :height="size" v-else class="profile-image" fluid :src="require('@/assets/img/avatar.jpg')" rounded="circle" alt="Profile image"></b-img>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    userId: String,
    size: {
      type: Number,
      required: false,
      default: 64
    }
  },
  methods: {
    ...mapActions('account', ['avatar'])
  },
  data: () => ({
    base64Data: null,
    unsubscribe: null
  }),
  created () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'account/avatarSuccess' && this.userId === mutation.payload.userUuid) {
        this.base64Data = mutation.payload.response
      }
    })
  },
  mounted () {
    if (this.userId && this.userId.length) {
      this.avatar(this.userId)
    }
  },
  destroyed () {
    this.unsubscribe()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AvatarImage.vue